import React from 'react';
import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './ReportsFilters.css';

export function ReportsFilters({ 
  searchQuery, 
  statusFilter, 
  yearFilter, 
  onSearchChange, 
  onStatusChange, 
  onYearChange, 
  onClearFilters 
}) {
  const { t } = useTranslation();
  const hasActiveFilters = searchQuery || statusFilter !== 'all' || yearFilter !== 'all';

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

  return (
    <div className="reports-filters">
      <div className="reports-filters__search-wrapper">
        <Search className="reports-filters__search-icon" size={18} />
        <input
          type="text"
          className="reports-filters__search-input"
          placeholder={t('reports.hub.filters.searchPlaceholder')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <select
        className="reports-filters__select"
        value={statusFilter}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="all">{t('reports.filters.allStatuses')}</option>
        <option value="draft">{t('reports.status.draft')}</option>
        <option value="in_progress">{t('reports.status.in_progress')}</option>
        <option value="needs_review">{t('reports.status.needs_review')}</option>
        <option value="completed">{t('reports.status.completed')}</option>
        <option value="locked">{t('reports.status.locked')}</option>
      </select>

      <select
        className="reports-filters__select"
        value={yearFilter}
        onChange={(e) => onYearChange(e.target.value)}
      >
        <option value="all">{t('reports.filters.allYears')}</option>
        {years.map(year => (
          <option key={year} value={year.toString()}>
            {year}
          </option>
        ))}
      </select>

      {hasActiveFilters && (
        <button
          className="reports-filters__clear-btn"
          onClick={onClearFilters}
        >
          <X size={16} />
          {t('reports.hub.filters.clear')}
        </button>
      )}
    </div>
  );
}
